export const GO_TO_PLAN_ALL_CANDIDATES_GENERATION_RETRY_INTERVAL = 20;
export const PLAN_ALL_GENERATION_RETRY_TIMES = 20;
